
import { Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { useTheme } from "@/components/ui/theme-provider";

interface DevotionalProgressProps {
  totalProgress?: number;
  currentStreak?: number;
  totalPoints: number;
  daysCompleted?: number;
}

export function DevotionalProgress({
  totalProgress = 0,
  currentStreak = 0,
  totalPoints,
  daysCompleted = 0
}: DevotionalProgressProps) {
  const { theme } = useTheme();

  const getCardClasses = () => {
    if (theme === "dark") {
      return "bg-app-surface/20 backdrop-blur-sm border border-app-border";
    }
    return "bg-app-surface border border-app-border";
  };

  const getTextColor = () => {
    return theme === "dark" ? "text-white" : "text-app-text-primary";
  };

  return (
    <div className={`${getCardClasses()} rounded-xl shadow-sm p-4 mb-6 transition-colors duration-300`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Star className="h-5 w-5 text-yellow-500 fill-yellow-500" />
          <span className={`font-semibold ${getTextColor()}`}>Points Available: {totalPoints}</span>
        </div>
        <Badge variant="secondary" className={getTextColor()}>
          {daysCompleted}/100 Days
        </Badge>
      </div>
      
      <div className="space-y-2">
        <div className={`flex justify-between text-sm ${getTextColor()}`}>
          <span>Progress</span>
          <span>{Math.round(totalProgress)}%</span>
        </div>
        <Progress value={totalProgress} className="h-2" />
      </div>

      {currentStreak > 0 && (
        <div className="mt-4 text-center">
          <Badge variant="secondary" className={getTextColor()}>
            🔥 {currentStreak} Day Streak!
          </Badge>
        </div>
      )}
    </div>
  );
}
